// extracted by mini-css-extract-plugin
module.exports = {"shinyText":"ShinyText_shinyText__fOOj5","shine":"ShinyText_shine__zurpO","disabled":"ShinyText_disabled__c7r6U"};